import * as yup from "yup";

const validation = yup.object({
  meta_title: yup.string().max(60, "Meta title must be up to 60 characters"),
  meta_description: yup.string().max(155, "Meta description must be up to 155 characters"),
});

export default validation;
